import { render, staticRenderFns } from "./LeagueGroups.vue?vue&type=template&id=49688f20&scoped=true&"
import script from "./LeagueGroups.vue?vue&type=script&lang=js&"
export * from "./LeagueGroups.vue?vue&type=script&lang=js&"
import style0 from "./LeagueGroups.vue?vue&type=style&index=0&id=49688f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49688f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon})
